import { useEffect, useState } from 'react'
import Link from 'next/link'
import Logo from '@components/common/logo'
import Spinner from '@components/common/spinner'
import BackgroundImageComponent from '@components/common/background-image'
import Ratings from '@components/common/ratings'
import Partners from '@components/locale-pages/home/us/partners'
import StudentCountriesOverview from '@components/home/student-countries-overview'

declare global {
  interface Window {
    hbspt: {
      forms: any
    }
  }
}

const FirstFold = (): JSX.Element => {
  const [formLoading, setFormLoading] = useState(true)
  useEffect(() => {
    const script = document.createElement('script')
    script.src = '//js.hsforms.net/forms/v2.js'
    script.async = true
    script.type = 'text/javascript'
    document.body.appendChild(script)
    script.onload = function () {
      window.hbspt.forms.create({
        target: '.school-partner-form',
        portalId: '8921313',
        formId: 'd238dc52-6760-44f2-975b-1ea8248b158f',
        css: '',
      })
      setFormLoading(false)
    }
  }, [])

  return (
    <>
      {' '}
      <div
        className="flex flex-col relative rounded-lg lg:px-4 lg:rounded-2xl"
        style={{
          background:
            'linear-gradient(0.94deg, #BF3240 -9.25%, #B73252 -0.72%, #7E36D9 104.12%), #FF5A43',
        }}
      >
        <Link href="/" prefetch={false}>
          <div>
            <Logo
              withText
              whiteText
              className="w-32 mt-6 ml-8 mr-2 h-8 lg:w-40 lg:h-12"
              alt="Codingal logo"
            />
          </div>
        </Link>
        <BackgroundImageComponent
          image="/images/school-partnership/first-fold/left-shapes.png"
          top={15}
          left={5}
          zIndex={0}
          alt="School workshop for kids page image"
        />
        <BackgroundImageComponent
          image="/images/school-partnership/first-fold/right-shapes.png"
          top={5}
          right={1}
          zIndex={0}
          alt="School workshop for kids page image"
        />
        <BackgroundImageComponent
          image="/images/school-partnership/first-fold/mobile-shapes.png"
          top={5}
          left={1}
          zIndex={0}
          className="lg:hidden"
          alt="School workshop for kids page image"
        />
        <div className="mx-auto rounded-lg mt-5 lg:rounded-2xl">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-40 pb-12">
            <div className="flex flex-col mt-20 mb-10 lg:mt-0 max-w-3xl lg:pl-10 lg:py-24 items-center text-center lg:items-start lg:text-left ">
              <div className="px-5 md:px-0">
                <Ratings />
              </div>
              <h1 className="mt-5 relative z-10 leading-tight text-white font-700 text-3xl lg:text-7xl lg:max-w-full text-center lg:text-left">
                Codingal - School Partnerships
              </h1>
              <h2 className="text-white text-xl lg:text-3xl font-300 lg:font-400 text-center px-5 lg:px-0 pt-5 lg:pt-10 pb-5 lg:text-left">
                We welcome schools to partner with us and introduce coding to
                students through fun activities.
              </h2>
              <StudentCountriesOverview />
            </div>
            <div
              className={`flex mt-5 justify-center align-center px-5 lg:px-0 lg:pr-10 lg:mt-0 z-10 ${
                formLoading ? 'embed-form-container' : ''
              }`}
            >
              <div className="bg-white rounded-md">
                {formLoading ? (
                  <Spinner classes="h-10 w-10 mt-40 justify-center align-center text-orange" />
                ) : (
                  <div className="embed-form-super-wrapper school-partner-form" />
                )}
                <div className="mb-5 text-center">
                  <a
                    href="https://calendly.com/shreya-choudhary-lui/consultation-with-shreya"
                    rel="noreferrer noopener"
                    target="_blank"
                    className="text-orange hover:underline font-600"
                  >
                    Click here to Schedule a free consultation
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="relative">
        <Partners />
      </div>
    </>
  )
}
export default FirstFold
